/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Starts Boost 211143 */

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
		componentRegistry.useComponentPlugin('FilterOption', {
		  name: 'FilterOption - Customize sorting',
		  apply: () => ({
		    props: (props) => {
		      // can custom for any Filter Option check props to customize for special FilterOption
		      let ids = ["pf_opt_size"];
		      if (ids.includes(props.option.filterOptionId)) {
		        props.customizeSorting = (values) => {
                        let strings = values.filter((e) => {
                          const temp = Number(e.key);
                          if (isNaN(temp)) {
                            return true;
                          }
                          return !(typeof Number(e.key) === 'number');
                        });
                        let numbers = values.filter((e) => {
                          const temp = Number(e.key);
                          if (isNaN(temp)) {
                            return false;
                          }
                          return (typeof Number(e.key) === 'number');
                        });
                        strings = strings.sort((a, b) => a.key.localeCompare(b.key));
                        numbers = numbers.sort((a, b) => a.key - b.key);
                        return [...numbers, ...strings];
                      };

		      }

		      return props;
		    },
		  }),
		});
}]);
/* Ends Boost 211143 */